import React, { ReactNode } from "react";

import { IntlShape } from "react-intl";

import ImportStatus from "@mapmycustomers/shared/enum/imports/ImportStatus";
import Import from "@mapmycustomers/shared/types/imports/Import";

import getSkipFileName from "@app/scene/settings/component/Imports/util/getSkipFileName";
import { downloadFile as downloadFileAction } from "@app/store/files/actions";

import DownloadSkipFile from "../ResultButtons/DownloadSkipFile";
import GoToDashboard from "../ResultButtons/GoToDashboard";
import GoToImportHistory from "../ResultButtons/GoToImportHistory";
import ReturnToImport from "../ResultButtons/ReturnToImport";

import doesImportHaveSkipFile from "./doesImportHaveSkipFile";

const getExtra = (
  intl: IntlShape,
  downloadFile: typeof downloadFileAction,
  importRecord?: Import
): ReactNode[] => {
  const extra: ReactNode[] = [];
  const haveWarnings = doesImportHaveSkipFile(importRecord);
  if (haveWarnings && !importRecord?.skipFileId) {
    extra.push(<GoToImportHistory key="go-to-import-history" />);
  } else if (haveWarnings && importRecord?.skipFileId) {
    extra.push(
      <ReturnToImport key="return-to-import" />,
      <DownloadSkipFile
        key="download-skip-file"
        onClick={() =>
          downloadFile({
            fileId: importRecord.skipFileId!,
            fileName: getSkipFileName(intl, importRecord),
          })
        }
      />
    );
  } else {
    extra.push(<ReturnToImport key="return-to-import" />);
    if (importRecord?.status !== ImportStatus.ERRORED) {
      extra.push(<GoToDashboard key="go-to-dashboard" />);
    }
  }
  return extra;
};

export default getExtra;
